export const APPAREL_PRODUCT_PRESET_SUBTYPE_DESCRIPTIONS: Record<
  string,
  string
> = {
  't-shirt/crew-neck':
    'A classic T-shirt with a round neckline and a closed collar line.',
  't-shirt/v-neck':
    'A T-shirt with a V-shaped neckline that opens to a front point.',
  't-shirt/scoop-neck':
    'A T-shirt with a wide curved neckline and a lower front drop.',
  't-shirt/henley':
    'A round-neck T-shirt finished with a short front button placket.',
  't-shirt/raglan':
    'A T-shirt with sleeves that reach the neckline along diagonal seams.',
  't-shirt/ringer':
    'A T-shirt defined by contrasting neck binding and bound sleeve openings.',
  't-shirt/pocket-t-shirt':
    'A crew-style T-shirt with a single patch pocket on the chest.',
  't-shirt/long-sleeve':
    'A T-shirt with wrist-length sleeves and a standard torso shape.',
  't-shirt/baseball':
    'A crew-neck T-shirt with three-quarter sleeves and raglan seams.',
  't-shirt/muscle':
    'A sleeveless T-shirt with open armholes and full torso length.',
  't-shirt/cap-sleeve':
    'A fitted T-shirt with short sleeves that just cover the shoulders.',
  't-shirt/mock-neck':
    'A T-shirt with a short raised neck and a closed collar line.',

  'hoodie/pullover':
    'A hooded sweatshirt with a closed front and no full-length opening.',
  'hoodie/full-zip':
    'A hooded sweatshirt with a zipper running the full length of the front.',
  'hoodie/half-zip':
    'A hooded sweatshirt with a partial zipper at the upper front.',
  'hoodie/sleeveless':
    'A hooded sweatshirt with open armholes and no attached sleeves.',
  'hoodie/anorak':
    'A hooded pullover with a partial front opening and a large front pocket.',
  'hoodie/funnel-neck':
    'A hoodie whose fixed hood meets a high, raised front collar.',
  'hoodie/cowl-neck':
    'A hoodie whose fixed hood flows into a soft, draped neckline.',

  'dress/a-line':
    'A fitted dress that widens gradually from the upper body to the hem.',
  'dress/wrap':
    'A dress with overlapping front panels secured at the side waist.',
  'dress/shirt':
    'A dress shaped around a shirt collar and a buttoned front opening.',
  'dress/slip':
    'A fluid, straight dress suspended from narrow shoulder straps.',
  'dress/sheath': 'A close-fitting dress with a straight, narrow skirt.',
  'dress/shift':
    'A straight dress with a loose body and minimal waist shaping.',
  'dress/fit-and-flare':
    'A dress with a fitted bodice and a skirt that flares from the waist.',
  'dress/empire-waist':
    'A dress with a raised waist seam and a skirt falling below the bust.',
  'dress/babydoll':
    'A short-bodice dress with a loose, gathered skirt starting high on the body.',
  'dress/column':
    'A long, narrow dress with a straight silhouette and consistent width.',
  'dress/mermaid':
    'A dress fitted through the knee before opening into a dramatic lower flare.',
  'dress/peplum':
    'A fitted-waist dress with a short overskirt projecting from the waist.',
  'dress/sweater':
    'A knitted pullover dress with a soft sweater-like construction.',
  'dress/gown': 'A formal dress with a fitted bodice and a floor-length skirt.',
  'dress/caftan':
    'A loose dress with a wide straight body and full-length sleeves.',

  'jean/straight-leg':
    'Jeans with a consistent leg width and a straight outer seam.',
  'jean/skinny':
    'Close-fitting jeans that remain narrow through the ankle opening.',
  'jean/slim':
    'Trim jeans that taper gently from the thigh through the lower leg.',
  'jean/relaxed':
    'Roomy jeans with extra ease through the seat, thigh, and leg.',
  'jean/tapered': 'Jeans with a roomy upper leg that narrows toward the ankle.',
  'jean/wide-leg':
    'Jeans that stay wide from the hip through a broad hem opening.',
  'jean/bootcut':
    'Jeans fitted through the thigh with a subtle flare below the knee.',
  'jean/flare':
    'Jeans fitted through the upper leg with a pronounced lower flare.',
  'jean/boyfriend':
    'Relaxed jeans with a roomy rise, loose seat, and rollable legs.',
  'jean/mom': 'High-rise jeans with roomy hips and a leg tapered at the ankle.',
  'jean/barrel-leg':
    'Jeans with legs that curve outward before tapering at the hem.',
  'jean/carpenter':
    'Straight utility jeans with functional pockets and a side tool loop.',

  'scarf/square': 'A flat scarf panel with four equal-length sides.',
  'scarf/oblong': 'A long rectangular scarf with a comparatively narrow width.',
  'scarf/infinity':
    'A continuous fabric loop designed to circle the neck without loose ends.',
  'scarf/shawl': 'A broad scarf long and wide enough to cover the shoulders.',
  'scarf/wrap': 'A long, wide scarf proportioned to wrap around the body.',
  'scarf/pashmina':
    'A generous rectangular scarf with enough width for soft draping.',
  'scarf/cowl': 'A short closed scarf loop that forms soft folds at the front.',
  'scarf/neckerchief':
    'A small square scarf scaled to tie closely around the neck.',
  'scarf/bandana':
    'A small square scarf designed to fold into a wearable triangle.',
  'scarf/blanket-scarf':
    'An oversized square scarf with broad coverage for layered wrapping.',
  'scarf/cravat': 'A narrow neck band that widens into decorative front tails.',

  'intimates/underwire-bra':
    'A supportive bra with shaped cups, under-cup wire channels, and adjustable shoulder straps.',
  'intimates/bralette':
    'A lightweight wireless bra with soft cups and a flexible underband.',
  'intimates/camisole':
    'A hip-length sleeveless underlayer suspended from narrow shoulder straps.',
  'intimates/slip':
    'A dress-length underlayer with a straight body and narrow shoulder straps.',
  'intimates/bodysuit':
    'A fitted one-piece undergarment joining a torso body to a brief-style lower section.',
  'intimates/classic-brief':
    'A waist-rise brief with full front and back coverage and moderate leg openings.',
  'intimates/bikini-brief':
    'A low-rise brief with high-cut leg openings and moderate rear coverage.',
  'intimates/hipster':
    'A low-slung brief with a straight hip-level waistband and low-cut legs.',
  'intimates/thong':
    'An undergarment with a full front panel and a narrow strip of rear coverage.',
  'intimates/boyshort':
    'A short full-coverage undergarment with low horizontal leg openings.',
  'intimates/boxer-brief':
    'A fitted trunk-style undergarment with a close body and short fitted legs.',
  'intimates/shapewear-short':
    'A high-rise compression undergarment extending into fitted mid-thigh legs.',
};
